class MgmColorSwatches extends HTMLElement {
  connectedCallback() {
    this.optionName = (this.dataset.optionName || 'Color').toLowerCase();
    this.hideNative = this.dataset.hideNative === 'true';
    this.addEventListener('change', this.onChange.bind(this));
    this.deferNativeSync();
    this.observeVariantPicker();
  }

  onChange(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    this.updateLabel(input.value);
    this.selectNativeOption(input.value);
  }

  deferNativeSync() {
    requestAnimationFrame(() => {
      this.syncFromNative();
      this.hideNativePicker();
    });

    setTimeout(() => {
      this.syncFromNative();
      this.hideNativePicker();
    }, 250);
  }

  syncFromNative() {
    const nativeInput = this.findNativeInput();
    const value = nativeInput?.value || this.querySelector('input[type="radio"]:checked')?.value;
    if (!value) return;

    const localInput = this.querySelector(`input[value="${CSS.escape(value)}"]`);
    if (localInput instanceof HTMLInputElement) localInput.checked = true;
    this.updateLabel(value);
  }

  updateLabel(value) {
    const label = this.querySelector('[data-mgm-selected-color]');
    if (label) label.textContent = value;
  }

  selectNativeOption(value) {
    const section = this.closest('.shopify-section') || document;
    const picker = section.querySelector('variant-picker');
    if (!picker) return;

    const nativeInput = Array.from(picker.querySelectorAll('input')).find((input) => {
      return input.dataset.optionName?.toLowerCase() === this.optionName && input.value === value;
    });

    if (nativeInput instanceof HTMLInputElement) {
      nativeInput.checked = true;
      nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const nativeSelect = Array.from(picker.querySelectorAll('select')).find((select) => {
      const selected = select.options[select.selectedIndex];
      return selected?.dataset.optionName?.toLowerCase() === this.optionName;
    });

    if (nativeSelect instanceof HTMLSelectElement) {
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  findNativeInput() {
    const section = this.closest('.shopify-section') || document;
    const picker = section.querySelector('variant-picker');
    if (!picker) return null;

    return Array.from(picker.querySelectorAll('input')).find((input) => {
      return input.dataset.optionName?.toLowerCase() === this.optionName && input.checked;
    });
  }

  hideNativePicker() {
    if (!this.hideNative) return;

    const section = this.closest('.shopify-section') || document;
    const picker = section.querySelector('variant-picker');
    if (!picker) return;

    const inputs = Array.from(picker.querySelectorAll('input')).filter((input) => {
      return input.dataset.optionName?.toLowerCase() === this.optionName;
    });

    for (const input of inputs) {
      const group = input.closest('fieldset, .variant-option');
      if (group instanceof HTMLElement) {
        group.hidden = true;
        group.style.display = 'none';
      }
    }
  }

  observeVariantPicker() {
    if (!this.hideNative || this.nativeObserver) return;

    const section = this.closest('.shopify-section') || document;
    const picker = section.querySelector('variant-picker');
    if (!picker) return;

    this.nativeObserver = new MutationObserver(() => {
      this.hideNativePicker();
      this.syncFromNative();
    });

    this.nativeObserver.observe(picker, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'data-current-checked'],
    });
  }
}

if (!customElements.get('mgm-color-swatches')) {
  customElements.define('mgm-color-swatches', MgmColorSwatches);
}
